import template from './filePreview.template.html';

export default {
  bindings: {},
  controller: class controller {
    constructor($mdDialog, $timeout, eventService, fileService) {
      'ngInject';

      const ctrl = this;
      ctrl.destroyWatch = null;

      ctrl.initialize = () => {
        ctrl.destroyWatch = eventService.onFilePreview((params) => {
          $mdDialog.show({
            targetEvent: params?.event || null,
            locals: {
              file: params?.file || {},
              type: params?.type || ''
            },
            template,
            controllerAs: '$ctrl',
            clickOutsideToClose: true,
            controller(file, type) {
              const self = this;
              self.file = file;
              self.type = type;
              self.currentImage = '';
              self.currentIndex = 0;
              self.totalPages = 0;
              self.renderedPages = 0;
              self.images = [];
              self.errorMessages = [];
              self.hasError = false;
              self.isOverLimit = false;
              self.isReady = false;

              fileService
                .preview({
                  file: self.file?.file,
                  type: self.type
                })
                .then((res) => {
                  if (res?.status) {
                    self.images = res?.results || [];
                    self.currentImage = self.images[0]?.imageLarge || '';
                    self.totalPages = res?.totalPages || 0;
                    self.renderedPages = res?.renderedPages || 0;
                    if (self.renderedPages < self.totalPages) {
                      self.isOverLimit = true;
                    }
                    $timeout(() => {
                      self.zoomImage();
                    });
                  } else {
                    self.hasError = true;
                    if (res?.errors?.length) {
                      const len = res?.errors?.length || 0;
                      for (let e = 0; e < len; e += 1) {
                        const error = res?.errors[e];
                        const message = error?.label
                          ? `${error?.label?.sanitize()} -> ${error?.message || ''}`
                          : error?.message || error || '';
                        self.errorMessages.push(message);
                      }
                    } else {
                      self.errorMessages.push(res?.errorMessage);
                    }
                    if (_.isEmpty(_.compact(self.errorMessages))) {
                      self.errorMessages.push('Could not load file');
                    }
                    self.errorMessages.unshift('File preview errors:');
                  }
                  self.isReady = true;
                });

              self.setZoomOptions = () => {
                self.currentZoomImg = document.getElementById('largeImage');
                self.currentImgWidth = self.currentZoomImg.clientWidth;
                self.maxZoomWidth = _.multiply(self.currentImgWidth, 2);
              };

              self.setActiveImage = (idx) => {
                self.currentImage = self.images[idx]?.imageLarge || '';
                self.currentIndex = idx;
                $timeout(() => {
                  self.zoomImage();
                }, 150);
              };

              self.prevNext = (isNext) => {
                if (isNext) {
                  const idx = self.currentIndex + 1;
                  self.currentImage =
                    idx >= self.images?.length
                      ? self.images[self.images?.length - 1]?.imageLarge
                      : self.images[idx]?.imageLarge;
                  self.currentIndex = idx >= self.images?.length ? self.currentIndex : idx;
                } else {
                  const idx = self.currentIndex - 1;
                  self.currentImage =
                    idx <= 0 ? self.images[0]?.imageLarge : self.images[idx]?.imageLarge;
                  self.currentIndex = idx <= 0 ? 0 : idx;
                }
                $timeout(() => {
                  self.zoomImage();
                }, 150);
              };

              self.zoomImage = (action) => {
                const wrapperZoomImg = document.getElementById('wrapper');
                const wrapperWidth = wrapperZoomImg.clientWidth - 40;
                const img = document.getElementById('largeImage');
                const width = img.clientWidth;
                const maxZoomWidth = _.multiply(width, 2);
                switch (action) {
                  case 'in':
                    if (width !== maxZoomWidth) {
                      img.style.width = `${width + 50}px`;
                    }
                    break;
                  case 'out':
                    if (width > wrapperWidth) {
                      img.style.width = `${width - 50}px`;
                    }
                    break;
                  default:
                    img.style.width = `${wrapperWidth}px`;
                    break;
                }
              };

              self.cancel = () => {
                $mdDialog.cancel();
              };
            }
          });
        });
      };

      ctrl.$onInit = () => {
        ctrl.initialize();
      };

      ctrl.$onDestroy = () => {
        ctrl.destroyWatch();
      };
    }
  }
};
